export const LoadMoreIcon = ({ className }: {className: string}) => (
  <svg className={className} viewBox="0 0 18 16" fill="none">
    <path d="M13.5242 3.86297C11.949 1.74822 9.34603 0.956141 7.01739 1.88294C4.68875 2.80973 3.13503 5.25615 3.13342 7.99848V9.77422" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M4.7334 12.4603C6.38311 14.3978 8.93223 15.024 11.166 14.0404C13.3998 13.0569 14.8663 10.6626 14.8667 7.99853V6.81628" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 7.40741L3.13333 9.77191L5.26667 7.40741" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.9999 9.18078L14.8666 6.81628L12.7333 9.18078" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
  );
